export default function createId() {
  return `new@${Date.now()}`;
}
